import { instance } from './ApiRequest';
import {
    INITIALIZE_NSDL, GET_REPORT_BY_CLIENT_ID, UPDATE_STUDENT_BIOMETRIC_DATA,
} from 'constants/constants';

let _BiometricAdminServices = {

    async InitializeNSDL(roleNumber) {
        return await instance.get(INITIALIZE_NSDL + "?roleNumber=" + roleNumber);
    },
    async GetReportByClientId(clientId) {
        return await instance.get(GET_REPORT_BY_CLIENT_ID + "?clinetId=" + clientId);
    },
    async updateStudentBiometricData(data) {
        return await instance.post(UPDATE_STUDENT_BIOMETRIC_DATA,data);
    }

}

export default _BiometricAdminServices;